
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Img1 from "./img/webp/1Plafond tendu circulaire avec éclairage LED intégré, design architectural moderne pour espace professionnel – UNIK SYSTEM.webp";
import Img2 from "./img/webp/13Façade architecturale moderne de la gare Rabat Agdal avec habillage et éclairage intégré.webp";
import Img3 from "./img/webp/26Plafond tendu lumineux circulaire avec éclairage LED RGB installé par UNIK SYSTEM dans un bowling moderne_imgupscaler..webp";

const carouselItems = [
  {
    img: Img1,
    subtitle: (
    <>
      <span className="subtitle-us">US</span> LIGHT
    </>
  ),
    title: "Solutions d’Éclairage Professionnelles & Design",
    text: "Optimisez vos espaces avec des solutions d’éclairage modernes, performantes et esthétiques adaptées aux environnements résidentiels et professionnels."
  },
  {
    img: Img2,
    subtitle: (
    <>
      <span className="subtitle-us">US</span> LIGHT
    </>
  ),
    title: "Éclairage LED Intérieur & Extérieur sur Mesure",
    text: "Spots LED, lignes lumineuses, éclairage architectural et solutions basse consommation pour bureaux, commerces et habitations."
  },
  {
    img: Img3,
    subtitle: (
    <>
      <span className="subtitle-us">US</span> LIGHT
    </>
  ),
    title: "Conception & Installation d’Éclairage Professionnel",
    text: "Étude lumineuse, installation experte et mise en valeur des espaces grâce à un éclairage fonctionnel, décoratif et durable."
  }
];


const HeaderCarousel = () => {
  return (
    <div className="container-fluid p-0" id="section1">

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
      >
        {carouselItems.map((item, index) => (
          <SwiperSlide key={index}>
                      <div className="position-relative">
          
                        {/* IMAGE */}
                        <img className="w-100 hero-img" src={item.img} alt={item.alt} loading="lazy"/>
          
                        {/* OVERLAY */}
                        <div className="hero-overlay d-flex align-items-center">
                          <div className="container">
                            <div  className="col-12 col-lg-8">
          
                              <h5 className="text-uppercase mb-2 text-white fw-bold tracking-in">
                                {item.subtitle}
                              </h5>
          
                              <h1 className="display-3 fw-bold text-white mb-4 slide-down" >
                                {item.title}
                              </h1>
          
                              <p className="fs-5 text-white mb-4 slide-up">
                                {item.text}
                              </p>
          
                              <a href="#titre-gallry" className="btn py-md-3 px-md-5 me-3 slide-left" id="pmt-link">
                                Voir nos réalisations
                              </a>
          
                              <a href="/devis" className="btn py-md-3 px-md-5 slide-left" id="pmt-link2">
                                Demander un devis
                              </a>
          
                            </div>
                          </div>
                        </div>
          
                      </div>
                    </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
};

export default HeaderCarousel;

